import { createLocalAudioTrack } from "livekit-client";
import { useMediaTrack } from "@/hooks/livekit/useMediaTrack";

interface UseLocalAudioOptions {
  enabled?: boolean;
}

export function useLocalAudio(opts?: UseLocalAudioOptions) {
  return useMediaTrack(createLocalAudioTrack, "audioinput", opts?.enabled);
}
